var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holder",class:{ closed: _vm.closed, border: _vm.border }},[_c('div',{staticClass:"header box-border",class:{ title: _vm.title },style:({
			'max-width': _vm.headerWidth ? `${_vm.headerWidth}px` : 'unset'
		}),on:{"click":_vm.toggle}},[(_vm.title)?_c('h3',{class:{ small: _vm.small }},[_vm._v(" "+_vm._s(_vm.currentTitle)+" ")]):_vm._e(),(_vm.closed)?_c('i',{staticClass:"lni lni-chevron-down"}):_c('i',{staticClass:"lni lni-chevron-up"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }